import { DocumentOrientation } from "pages/flyer/builder/drawer/types";
import { createShapesPropsFormat } from "../types";

export const shapesTEARAWAY: createShapesPropsFormat = (
  editor,
  isPortraitParam,
  centerX,
  centerY,
  displayWidth,
  displayHeight,
  frontBgAssetId,
  safetyZonePx,
  bleedsZonePx,
  logo,
  qrCode,
  existSnapshot,
  isUpdateShapesPosition,
  defaultOrientation
) => {
  const FIX_GAP = 1.65;

  const isPortrait = !isPortraitParam;

  if (
    centerX === undefined ||
    centerY === undefined ||
    displayWidth === undefined ||
    displayHeight === undefined ||
    safetyZonePx === undefined ||
    bleedsZonePx === undefined
  ) {
    return;
  }

  if (existSnapshot) {
    editor.run(
      () => {
        // 🔄 Update shapes - include positions ONLY when format changes
        if (isUpdateShapesPosition) {
          // ✅ Format changed: Reset ALL positions to default (including labels)
          editor.updateShapes([
            {
              id: "shape:backLabel" as any,
              type: "customLabel",
              isLocked: false,
              x: centerX + displayWidth / FIX_GAP + displayWidth / 2 - 35,
              y: centerY - 70,
              props: {
                t: "Back",
                w: 70,
                h: 50,
                allowUpdate: true,
              },
            },
            {
              id: "shape:frontLabel" as any,
              type: "customLabel",
              isLocked: false,
              x: centerX - displayWidth / FIX_GAP + displayWidth / 2 - 35,
              y: centerY - 70,
              props: {
                t: "Front",
                w: 70,
                h: 50,
                allowUpdate: true,
              },
            },
          ]);
          // ✅ Format changed: Reset positions to default + update dimensions
          editor.updateShapes([
            {
              id: "shape:front" as any,
              type: "format",
              x: centerX - displayWidth / FIX_GAP,
              y: centerY,
              isLocked: true,
              rotation: 0,
              props: {
                w: displayWidth,
                h: displayHeight,
              },
            },
            {
              id: "shape:back" as any,
              type: "format",
              x: centerX + displayWidth / FIX_GAP,
              y: centerY,
              isLocked: true,
              props: {
                w: displayWidth,
                h: displayHeight,
              },
            },
            {
              id: "shape:frontRedLine" as any,
              type: "redLine",
              x: centerX - displayWidth / FIX_GAP,
              y: centerY,
              isLocked: true,
              rotation: 0,
              props: {
                w: displayWidth,
                h: displayHeight,
                isDoorHanger: false,
              },
            },
            {
              id: "shape:backRedLine" as any,
              type: "redLine",
              x: centerX + displayWidth / FIX_GAP,
              y: centerY,
              isLocked: true,
              rotation: 0,
              props: {
                w: displayWidth,
                h: displayHeight,
                isDoorHanger: false,
              },
            },
            {
              id: "shape:frontBlackLine" as any,
              type: "blackLine",
              x: centerX - displayWidth / FIX_GAP - bleedsZonePx / 2,
              y: centerY - bleedsZonePx / 2,
              isLocked: true,
              rotation: 0,
              props: {
                w: displayWidth + bleedsZonePx,
                h: displayHeight + bleedsZonePx,
              },
            },
            {
              id: "shape:backBlackLine" as any,
              type: "blackLine",
              x: centerX + displayWidth / FIX_GAP - bleedsZonePx / 2,
              y: centerY - bleedsZonePx / 2,
              isLocked: true,
              rotation: 0,
              props: {
                w: displayWidth + bleedsZonePx,
                h: displayHeight + bleedsZonePx,
              },
            },
            {
              id: "shape:frontBorderDashLine" as any,
              type: "dash-border",
              x: centerX - displayWidth / FIX_GAP + safetyZonePx / 2,
              y: centerY + safetyZonePx / 2,
              isLocked: true,
              props: {
                w: displayWidth - safetyZonePx,
                h: displayHeight - safetyZonePx,
                isDoorHanger: false,
              },
            },
            {
              id: "shape:backBorderDashLine" as any,
              type: "dash-border",
              x: centerX + displayWidth / FIX_GAP + safetyZonePx / 2,
              y: centerY + safetyZonePx / 2,
              isLocked: true,
              props: {
                w: displayWidth - safetyZonePx,
                h: displayHeight - safetyZonePx,
                isDoorHanger: false,
              },
            },
          ]);
        } else {
          // 🔒 Normal load: Update ONLY dimensions, preserve saved positions
          editor.updateShapes([
            {
              id: "shape:front" as any,
              type: "format",
              isLocked: true,
              rotation: 0,
              props: {
                w: displayWidth,
                h: displayHeight,
              },
            },
            {
              id: "shape:back" as any,
              type: "format",
              isLocked: true,
              props: {
                w: displayWidth,
                h: displayHeight,
              },
            },
            {
              id: "shape:frontRedLine" as any,
              type: "redLine",
              isLocked: true,
              rotation: 0,
              props: {
                w: displayWidth,
                h: displayHeight,
                isDoorHanger: false,
              },
            },
            {
              id: "shape:backRedLine" as any,
              type: "redLine",
              isLocked: true,
              rotation: 0,
              props: {
                w: displayWidth,
                h: displayHeight,
                isDoorHanger: false,
              },
            },
            {
              id: "shape:frontBlackLine" as any,
              type: "blackLine",
              isLocked: true,
              rotation: 0,
              props: {
                w: displayWidth + bleedsZonePx,
                h: displayHeight + bleedsZonePx,
              },
            },
            {
              id: "shape:backBlackLine" as any,
              type: "blackLine",
              isLocked: true,
              rotation: 0,
              props: {
                w: displayWidth + bleedsZonePx,
                h: displayHeight + bleedsZonePx,
              },
            },
            {
              id: "shape:frontBorderDashLine" as any,
              type: "dash-border",
              isLocked: true,
              props: {
                w: displayWidth - safetyZonePx,
                h: displayHeight - safetyZonePx,
                isDoorHanger: false,
              },
            },
            {
              id: "shape:backBorderDashLine" as any,
              type: "dash-border",
              isLocked: true,
              props: {
                w: displayWidth - safetyZonePx,
                h: displayHeight - safetyZonePx,
                isDoorHanger: false,
              },
            },
          ]);
        }
      },
      { ignoreShapeLock: true }
    );
  } else {
    editor.createShapes([
      {
        id: "shape:backLabel" as any,
        type: "customLabel",
        isLocked: false,
        x: centerX + displayWidth / FIX_GAP + displayWidth / 2 - 35,
        y: centerY - 70,
        props: {
          t: "Back",
          w: 70,
          h: 50,
          allowUpdate: true,
        },
      },
      {
        id: "shape:frontLabel" as any,
        type: "customLabel",
        isLocked: false,
        x: centerX - displayWidth / FIX_GAP + displayWidth / 2 - 35,
        y: centerY - 70,
        props: {
          t: "Front",
          w: 70,
          h: 50,
          allowUpdate: true,
        },
      },
      {
        id: "shape:front" as any,
        type: "format",
        x: centerX - displayWidth / FIX_GAP,
        y: centerY,
        isLocked: true,
        rotation: 0,
        props: {
          w: displayWidth,
          h: displayHeight,
        },
      },
      {
        id: "shape:back" as any,
        type: "format",
        x: centerX + displayWidth / FIX_GAP,
        y: centerY,
        isLocked: true,
        props: {
          w: displayWidth,
          h: displayHeight,
        },
      },
      {
        id: "shape:frontRedLine" as any,
        type: "redLine",
        x: centerX - displayWidth / FIX_GAP,
        y: centerY,
        isLocked: true,
        rotation: 0,
        props: {
          w: displayWidth,
          h: displayHeight,
          isDoorHanger: false,
        },
      },
      {
        id: "shape:backRedLine" as any,
        type: "redLine",
        x: centerX + displayWidth / FIX_GAP,
        y: centerY,
        isLocked: true,
        rotation: 0,
        props: {
          w: displayWidth,
          h: displayHeight,
          isDoorHanger: false,
        },
      },
      {
        id: "shape:frontBlackLine" as any,
        type: "blackLine",
        x: centerX - displayWidth / FIX_GAP - bleedsZonePx / 2,
        y: centerY - bleedsZonePx / 2,
        isLocked: true,
        rotation: 0,
        props: {
          w: displayWidth + bleedsZonePx,
          h: displayHeight + bleedsZonePx,
        },
      },
      {
        id: "shape:backBlackLine" as any,
        type: "blackLine",
        x: centerX + displayWidth / FIX_GAP - bleedsZonePx / 2,
        y: centerY - bleedsZonePx / 2,
        isLocked: true,
        rotation: 0,
        props: {
          w: displayWidth + bleedsZonePx,
          h: displayHeight + bleedsZonePx,
        },
      },
      {
        id: "shape:frontBorderDashLine" as any,
        type: "dash-border",
        isLocked: true,
        x: centerX - displayWidth / FIX_GAP + safetyZonePx / 2,
        y: centerY + safetyZonePx / 2,
        props: {
          w: displayWidth - safetyZonePx,
          h: displayHeight - safetyZonePx,
          isDoorHanger: false,
        },
      },
      {
        id: "shape:backBorderDashLine" as any,
        type: "dash-border",
        isLocked: true,
        x: centerX + displayWidth / FIX_GAP + safetyZonePx / 2,
        y: centerY + safetyZonePx / 2,
        props: {
          w: displayWidth - safetyZonePx,
          h: displayHeight - safetyZonePx,
          isDoorHanger: false,
        },
      },
    ]);
  }

  if (isUpdateShapesPosition) {
    editor.updateShapes([
      {
        id: "shape:backLabel" as any,
        type: "customLabel",
        x: centerX + displayWidth / FIX_GAP + displayWidth / 2 - 35,
        y: centerY - 70,
        props: {
          t: "Back",
          w: 70,
          h: 50,
          allowUpdate: true,
        },
      },
      {
        id: "shape:frontLabel" as any,
        type: "customLabel",
        x: centerX - displayWidth / FIX_GAP + displayWidth / 2 - 35,
        y: centerY - 70,
        props: {
          t: "Front",
          w: 70,
          h: 50,
          allowUpdate: true,
        },
      },
      {
        id: "shape:front" as any,
        type: "format",
        x: centerX - displayWidth / FIX_GAP,
        y: centerY,
        isLocked: true,
        props: {
          w: displayWidth,
          h: displayHeight,
        },
      },
      {
        id: "shape:back" as any,
        type: "format",
        x: centerX + displayWidth / FIX_GAP,
        y: centerY,
        isLocked: true,
        props: {
          w: displayWidth,
          h: displayHeight,
        },
      },
      {
        id: "shape:frontRedLine" as any,
        type: "redLine",
        x: centerX - displayWidth / FIX_GAP,
        y: centerY,
        isLocked: true,
        props: {
          w: displayWidth,
          h: displayHeight,
          isDoorHanger: false,
        },
      },
      {
        id: "shape:backRedLine" as any,
        type: "redLine",
        x: centerX + displayWidth / FIX_GAP,
        y: centerY,
        isLocked: true,
        props: {
          w: displayWidth,
          h: displayHeight,
          isDoorHanger: false,
        },
      },
      {
        id: "shape:frontBlackLine" as any,
        type: "blackLine",
        x: centerX - displayWidth / FIX_GAP - bleedsZonePx / 2,
        y: centerY - bleedsZonePx / 2,
        isLocked: true,
        props: {
          w: displayWidth + bleedsZonePx,
          h: displayHeight + bleedsZonePx,
        },
      },
      {
        id: "shape:backBlackLine" as any,
        type: "blackLine",
        x: centerX + displayWidth / FIX_GAP - bleedsZonePx / 2,
        y: centerY - bleedsZonePx / 2,
        isLocked: true,
        props: {
          w: displayWidth + bleedsZonePx,
          h: displayHeight + bleedsZonePx,
        },
      },
      {
        id: "shape:frontBorderDashLine" as any,
        type: "dash-border",
        isLocked: true,
        x: centerX - displayWidth / FIX_GAP + safetyZonePx / 2,
        y: centerY + safetyZonePx / 2,
        props: {
          w: displayWidth - safetyZonePx,
          h: displayHeight - safetyZonePx,
          isDoorHanger: false,
        },
      },
      {
        id: "shape:backBorderDashLine" as any,
        type: "dash-border",
        isLocked: true,
        x: centerX + displayWidth / FIX_GAP + safetyZonePx / 2,
        y: centerY + safetyZonePx / 2,
        props: {
          w: displayWidth - safetyZonePx,
          h: displayHeight - safetyZonePx,
          isDoorHanger: false,
        },
      },
    ]);
  }
};
